import { a9 as fallback, a1 as spread_props, a7 as stringify, a0 as bind_props, P as pop, aa as sanitize_props, N as push } from "./index.js";
import { B as Button } from "./Button.js";
import "./analytics.js";
function DownloadButton($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  let primary = fallback($$props["primary"], true);
  let size = fallback($$props["size"], 0);
  let background = fallback($$props["background"], "dark");
  let enableStoreDownload = fallback($$props["enableStoreDownload"], false);
  Button($$payload, spread_props([
    $$sanitized_props,
    {
      background,
      class: `download-button $${stringify($$sanitized_props.class ?? "")}`,
      label: "Download for Windows",
      primary,
      secondaryLabel: "Free",
      size,
      startIcon: "mdi:microsoft"
    }
  ]));
  $$payload.out += `<!----> `;
  if (enableStoreDownload) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<a href="ms-windows-store://pdp/?productid=XP89FPP9MX5S91">`;
    Button($$payload, {
      primary: false,
      background,
      size,
      class: "download-button",
      startIcon: "mdi:shopping",
      label: "Get it from the Microsoft Store",
      secondaryLabel: "Free"
    });
    $$payload.out += `<!----></a>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, {
    primary,
    size,
    background,
    enableStoreDownload
  });
  pop();
}
export {
  DownloadButton as D
};
